"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "deleteOverlay", {
  enumerable: true,
  get: function get() {
    return _deleteOverlay["default"];
  }
});
var _deleteOverlay = _interopRequireDefault(require("./deleteOverlay"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }